var map = {
	"./dualing.png": 9996,
	"./learnergy.png": 3789,
	"./libdeep.png": 785,
	"./libdev.png": 5070,
	"./libopf.png": 7186,
	"./libopt.png": 240,
	"./nalp.png": 5443,
	"./opfython.png": 7773,
	"./opytimark.png": 910,
	"./opytimizer.png": 8512,
	"./statys.png": 9062,
	"./textfier.png": 5911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5130;